import { Layer, LayerLayerTypeEnum } from '@datum-group/isogd-openapi/lib';
import { LayerGroupNode } from './LayerGroupNode';
import { LayerNode } from './LayerNode';
import { RootNode } from './RootNode';
import { TableLayerNode } from './TableLayerNode';
import {
  APILayer,
  APILayerGroup,
  APITableLayer,
  TreeContext,
  TreeServices,
} from './types';

export const buildNodeFromApiLayer = (
  layer: Layer,
  parent: RootNode | LayerGroupNode,
  context: TreeContext,
  services: TreeServices,
) => {
  if (layer.layer_type === LayerLayerTypeEnum.LayersGroup) {
    return new LayerGroupNode(
      layer as APILayerGroup,
      parent,
      context,
      services,
    );
  }

  if (layer.layer_type === LayerLayerTypeEnum.Table) {
    return new TableLayerNode(
      layer as APITableLayer,
      parent,
      context,
      services,
    );
  }

  return new LayerNode(layer as APILayer, parent);
};

export const findLayersNode = (
  children: (LayerGroupNode | LayerNode | TableLayerNode)[],
) => {
  const nodes: LayerNode[] = [];

  children.forEach((child) => {
    if (child instanceof LayerNode) nodes.push(child);
  });

  return nodes;
};

export const findTableLayersNode = (
  children: (LayerGroupNode | LayerNode | TableLayerNode)[],
) => {
  const nodes: TableLayerNode[] = [];

  children.forEach((child) => {
    if (child instanceof TableLayerNode) nodes.push(child);
  });

  return nodes;
};

export const findLayerGroupNode = (
  children: (LayerGroupNode | LayerNode | TableLayerNode)[],
) => {
  const nodes: LayerGroupNode[] = [];

  children.forEach((child) => {
    if (child instanceof LayerGroupNode) nodes.push(child);
  });

  return nodes;
};

export const getDisplayGeoJSONFeature = (
  feature: GeoJSON.Feature,
  display: string,
) => {
  const properties = {
    ...feature?.properties,
    id: feature.id,
  };

  return getDisplayProps(properties, display);
};

const getDisplayProps = (props: Record<string, any>, display: string) => {
  let tableField = display ?? '';
  if (tableField === '') {
    return tableField;
  }

  const re = /{(\w+)}/g;
  const result = tableField.match(re);

  if (result) {
    result.forEach((item) => {
      const fieldName = item.replace(/\{|\}/g, '');
      const field = props[fieldName] ?? '';
      tableField = tableField.replace(item, field);
    });
  }

  return tableField;
};
